import { ResponseLoginVoucher } from '@/infra/BirdId/controllers/login.controller'
import {
  FormDataType,
  useDynamicForms,
} from '@/store/Pinia/useDynamicForms.store'
import { useRouteBirdId } from '@/store/Pinia/useRouteBirdId.store'
import {
  StateSolicitation,
  useSolicitation,
} from '@/store/Pinia/useSolicitation.store'
import { useMainStore } from '@/store/Pinia/useMain.store'
import { getMunicipioByIBGECode } from './getMunicipioByNameAndUF'

export default function saveDataVoucher(payload: ResponseLoginVoucher) {
  const solicitationStore = useSolicitation()
  const dynamicFormStore = useDynamicForms()
  const routeBirdIdStore = useRouteBirdId()
  const mainStore = useMainStore()

  const solicitationModel = {
    isBirdId: payload.isBird,
    voucher: payload.voucher,
    isPj: payload.isPj,
    isSSL: payload.produto.isSSL,
    produto: {
      id: payload.produto.id,
      nome: payload.nomeProduto,
      sku: payload.produto.sku,
      cei: '',
      pis: '',
    },
    solicitationToken: {
      sessionData: payload.sessionData,
      sessionId: payload.sessionId,
    },
  } as StateSolicitation

  let formDataModel = {
    cei: '',
    pis: '',
    idunidade: payload.idunidade || '',
    nome: payload.nome || dynamicFormStore.getFormData.nome,
    cpf: payload.cpf || dynamicFormStore.getFormData.cpf,
    cnpj: dynamicFormStore.getFormData.cnpj || '',
  } as FormDataType

  if (payload.dataDecrypted) {
    const decryptedData = payload.dataDecrypted as Record<string, unknown>
    const formFieldIds = new Set(
      dynamicFormStore.formInfo.map((field) => field.id),
    )

    const dynamicPrefillData = Object.entries(decryptedData).reduce(
      (acc, [key, value]) => {
        if (value === null || value === undefined || key === 'municipio') {
          return acc
        }

        const isKnownFormDataField = Object.prototype.hasOwnProperty.call(
          dynamicFormStore.getFormData,
          key,
        )
        const isCurrentDynamicField = formFieldIds.has(key)
        const isFormField = isKnownFormDataField || isCurrentDynamicField

        if (!isFormField) {
          return acc
        }

        return {
          ...acc,
          [key]: value,
        }
      },
      {} as Record<string, unknown>,
    )

    const municipio = getMunicipioByIBGECode(payload.dataDecrypted.municipio)

    formDataModel = {
      ...formDataModel,
      senha: payload.dataDecrypted.senha || '',
      senhaConfirm: payload.dataDecrypted.senhaConfirm || '',
      ...dynamicPrefillData,
      municipio: municipio?.nome || '',
      uf: payload.dataDecrypted.uf,
    }
  }

  if (payload.qsaResponseData) {
    formDataModel = {
      ...formDataModel,
      qsaResponseData: payload.qsaResponseData,
    }

    if (payload.qsaResponseData.razao_social) {
      formDataModel = {
        ...formDataModel,
        razao_social: payload.qsaResponseData.razao_social,
      }
    }
  }

  if (payload.cei !== '000000000000' && payload.cei !== '') {
    solicitationModel.produto.cei = payload.cei
  }
  if (payload.pis !== '00000000000' && payload.pis !== '') {
    solicitationModel.produto.pis = payload.pis
  }

  solicitationStore.saveDataSolicitation(solicitationModel)
  dynamicFormStore.setMunicipios(payload.municipios)
  dynamicFormStore.setFormData(formDataModel)
  mainStore.idunidade = payload.idunidade || ''
  routeBirdIdStore.setRouterDone('voucher')
}
